import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($filter, $scope, $state, $q, $stateParams, ModalService, ServiceRequestService, ViewModelService, $window, httpSettings) => {
    let _serviceRequestQuoteForm;
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.serviceRequest = $state.current.data.serviceRequest;
        const quote = angular.copy($scope.serviceRequest.latestQuote) ||
            {
                totalAmount: {}
            };
        const quoteAlreadyExists = !!$scope.serviceRequest.latestQuote;

        $scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ServiceRequestDocumentError`;
        $scope.claimCenterDownloadURI = `${httpSettings.serviceBaseURLs.cc}document/servicerequest/servicerequestDocument`;
        $scope.recentlyAddedDocuments = []; // List of documents associated to the SR - reduced to an array of PublicID[] when sent to server
        $scope.quoteView = ViewModelService.create(quote, 'cc', 'edge.capabilities.servicerequest.statement.quote.dto.ServiceRequestQuoteDTO');
        $scope.tableConfig = {
            attachingDocuments: false, // Passed to documents directive - enables/disables buttons depending on document attachment state
            paginationSize: 1000
        };

        if (quote.documents && $scope.serviceRequest.documents) {
            $scope.quoteView.documents.value = quote.documents.map((document) => {
                if (!document.publicID) {
                    return document;
                }
                return _.find($scope.serviceRequest.documents, {
                    publicID: document.publicID
                }) || document;
            });
        }

        if (quoteAlreadyExists) {
            $scope.quoteView.existingDocumentsToLink.value = $scope.quoteView.documents.value;
        } else {
            $scope.quoteView.existingDocumentsToLink.value = [];
        }

        // don't show no attached documents error message if there are attached documents
        // to the form
        $scope.$watch('quoteView.existingDocumentsToLink.length', (newLength, oldLength) => {
            if (oldLength !== newLength) {
                if (_serviceRequestQuoteForm) {
                    _serviceRequestQuoteForm.$setValidity('noDocuments', !!(newLength));
                }
            }
        });
    };

    ctrl.addQuote = (serviceRequestQuoteForm) => {
        _serviceRequestQuoteForm = serviceRequestQuoteForm;
        if ($scope.quoteView.existingDocumentsToLink.length === 0) {
            serviceRequestQuoteForm.submitted = true;
            serviceRequestQuoteForm.$setValidity('noDocuments', false);
            return;
        }
        serviceRequestQuoteForm.$setValidity('noDocuments', true);

        serviceRequestQuoteForm.submitted = true;

        if (serviceRequestQuoteForm.$valid && $scope.quoteView.aspects.subtreeValid) {
            // Associate existing documents from the service request.
            $scope.quoteView.existingDocumentsToLink.value = _.map($scope.quoteView.existingDocumentsToLink.value, 'publicID');

            $scope.submitQuotePromise = ServiceRequestService.addOrReplaceQuote($scope.serviceRequest.publicID, $scope.quoteView.value).then(
                (/* newQuote*/) => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.serviceRequest.serviceRequestNumber});
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.QuoteDetailsCtrl.Service Request update failed',
                        'servicerequest.controllers.QuoteDetailsCtrl.Sorry, we were not able to add a quote to your service request'
                    );
                }
            );
        }
    };

    ctrl.reviseQuote = () => {
        const state = $state.get('addOrReviseQuote');
        state.data.serviceRequest = $scope.serviceRequest;
        state.data.oldQuote = $scope.serviceRequest.latestQuote;
        $state.transitionTo(state);
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$q', '$stateParams', 'ModalService', 'servicerequest.ServiceRequestService', 'ViewModelService', '$window', 'httpSettings'];
export default fn;
